/* global CONFIG */
// import moment from 'moment'

export default {
  setuser (VueApp) {
    if (window.fcWidget) {
      let user = VueApp.$store.state.user
      window.fcWidget.init({
        token: '4bdadd95-c9ee-4672-898c-70d1e4129b77',
        host: 'https://wchat.freshchat.com',
        externalId: user.id,
        tags: ['widget']
      })

      window.fcWidget.user.get(function (resp) {
        let status = resp && resp.status
        if (status !== 200) {
          let user = VueApp.$store.state.user
          let currentBrand = ''
          for (let brand in CONFIG.Brands) {
            if (CONFIG.Brands[brand].id === VueApp.$store.state.brandId) {
              currentBrand = CONFIG.Brands[brand].name
            }
          }
          window.fcWidget.user.setProperties({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            phoneNumber: user.phone.number,
            countryCode: '+' + user.phone.code,
            userId: user.id,
            is_consumer: true,
            platform: 'web',
            brand: currentBrand
          })
          window.fcWidget.on('user:created', function (resp) {
            let status = resp && resp.status
            let data = resp && resp.data;
            if (status === 200) {
              if (data.restoreId) {
                // Update restoreId in your database
              }
            }
          })
        }
      })
    } else {
      this.noFCWidget()
    }
  },
  noFCWidget () { console.warn('** No Freshchat Widget detected! **') }
}



// WEBPACK FOOTER //
// ./src/modules/api/freshchat.js